/**
 * JWT utilities
 */

/**
 * @typedef {Object} JwtPayload
 * @property {number} [exp] - Expiration timestamp
 * @property {number} [iat] - Issued at timestamp
 * @property {*} [key] - Any other claims
 */

/**
 * Декодирует JWT без валидации подписи.
 * Возвращает payload либо null при некорректном токене.
 * 
 * @param {string|null} [token] - JWT token
 * @returns {JwtPayload|null} - Decoded payload or null
 */
export function decodeToken(token) {
  if (!token) return null;
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (_e) {
    return null;
  }
}

/**
 * Проверяет JWT на валидность по exp и наличию payload.
 * Подпись не проверяется на клиенте.
 * 
 * @param {string|null} [token] - JWT token
 * @returns {{valid: boolean, payload?: JwtPayload, error?: string}} - Verification result
 */
export function verifyJWT(token) {
  try {
    const decoded = decodeToken(token);
    if (!decoded) return { valid: false, error: 'Invalid token' };
    const currentTimestamp = Math.floor(Date.now() / 1000);
    if (typeof decoded.exp === 'number' && decoded.exp < currentTimestamp) {
      return { valid: false, error: 'Token expired' };
    }
    return { valid: true, payload: decoded };
  } catch (_e) {
    return { valid: false, error: 'Invalid token' };
  }
}
